import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modals } from '@/constants';
import { LoginForm, RegisterForm } from '@/containers';
import { AnalyticsService, EVENTS } from '@/services';
import { selectActiveModalParams, uiActions, useAppSelector } from '@/store';
import { setRedirectSearchParams } from '@/utils';

export const SignupModalContent = () => {
  const dispatch = useDispatch();
  const { defaultShowLogin } = useAppSelector(selectActiveModalParams) || {};
  const [showLogin, setShowLogin] = useState(defaultShowLogin);

  const { referrer, redirect } = useSelector(selectActiveModalParams) ?? {};

  useEffect(() => {
    if (redirect) {
      const { origin, search } = window.location;
      const searchParams = new URLSearchParams(search);
      searchParams.set('redirect', `${origin}${redirect}`);
      setRedirectSearchParams(searchParams);
    }
  }, [redirect]);

  const handleClose = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('redirect');
    setRedirectSearchParams(searchParams);
    dispatch(uiActions.closeActiveModal());
  };

  const onSuccess = () => {
    dispatch(uiActions.closeActiveModal());
  };

  useEffect(() => {
    if (showLogin) return;
    AnalyticsService.logEvent(EVENTS.MARKETING_EVENTS.SIGNUP_VIEWED);
  }, [showLogin]);

  return (
    <>
      {showLogin ? (
        <LoginForm
          onSignUpClick={() => setShowLogin(false)}
          onLoginSuccess={onSuccess}
          onModalClose={handleClose}
          referrer={referrer}
        />
      ) : (
        <RegisterForm
          subtitle={'Start your free trial! No credit card required.'}
          showLeftColumn
          onLoginClick={() => setShowLogin(true)}
          onRegisterSuccess={onSuccess}
          onModalClose={handleClose}
          referrer={{
            ...(referrer ?? {}),
            modalName: Modals.SIGN_UP,
          }}
        />
      )}
    </>
  );
};
